import { bool, number, oneOf, string, shape } from 'prop-types';
import React from 'react';
import Figure from 'components/Figure';
import Html from 'components/Html';
import { MQ_MEDIUM } from 'constants/mq';
import styles from './styles';

const SIZES = {
  large: [
    {
      media: MQ_MEDIUM,
      layoutWidth: {
        value: 334,
        units: 'px'
      }
    },
    {
      layoutWidth: {
        value: 100,
        units: 'vw'
      }
    }
  ],
  small: [
    {
      layoutWidth: {
        value: 200,
        units: 'px'
      }
    }
  ]
};

const MAX_WIDTH = {
  large: 334,
  small: 200
};

export default function SideBySide({
  image,
  html,
  isAffiliate,
  hasPrism,
  post,
  variant
}) {
  const figureProps = {
    ...image,
    ...(variant === 'small'
      ? {
          // Small
          aspectRatio: 1,
          resizeMode: 'crop',
          hasPrism: false,
          isPinnable: false,
          // TEMP: override caption and credit so it doesn't show. We should
          // rework Figure to take a hideInfo prop and use this for the interrupter
          // as well.
          caption: undefined,
          credit: undefined
        }
      : {
          // Large
          hasPrism
        }),
    ...{
      placement: 'sideBySide',
      maxWidth: MAX_WIDTH[variant],
      sourceSizes: SIZES[variant],
      isAffiliate,
      post
    }
  };

  return (
    <div className={`SideBySide SideBySide--${variant}`}>
      <Figure {...figureProps} />
      <Html html={html} isAffiliate={isAffiliate} />
      <style jsx>{styles}</style>
    </div>
  );
}

SideBySide.defaultProps = {
  html: '',
  image: {},
  variant: 'large',
  post: undefined,
  isAffiliate: false,
  hasPrism: false
};

SideBySide.propTypes = {
  html: string,
  image: shape({
    url: string,
    alt: string,
    caption: string,
    href: string,
    isPinnable: bool,
    originalWidth: number,
    originalHeight: number
  }),
  variant: oneOf(['large', 'small']),
  post: shape({
    canonical: string
  }),
  isAffiliate: bool,
  hasPrism: bool
};
